module.exports = __webpack_public_path__ + "media/images/dashboard/grade_level-0549ed51251130a193e9bdb171827b11.svg";